<div class="box-footer">
    <span *ngIf="showVersion"> نسخه <i>{{appVersion}}</i></span>
    <img [src]="imgSrc" alt="">
</div>
